import { render, staticRenderFns } from "./GuestioTalent.vue?vue&type=template&id=1ebc85d0"
import script from "./GuestioTalent.vue?vue&type=script&lang=js"
export * from "./GuestioTalent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports